import { render, staticRenderFns } from "./ShipmentsView.vue?vue&type=template&id=fe4a7cba"
import script from "./ShipmentsView.vue?vue&type=script&lang=js"
export * from "./ShipmentsView.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsView.vue?vue&type=style&index=0&id=fe4a7cba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports